import React, { useState, useEffect } from "react";

import { Box, Chip, CircularProgress, Grid, Typography } from "@mui/material";

import AccountCircle from "@mui/icons-material/AccountCircle";
import HistoryIcon from "@mui/icons-material/History";

import moment from "moment";

import { useSelector, useDispatch } from "react-redux";
import { updateChatID } from "../redux/threadSlice";
// import { wsApiGateway } from "../constants/urls";

import logo from "../static/logo.png";
import VideoCard from "./VideoCard";

import { useSocket } from "../constants/useSocket";
import Carousel from "./Carousel";
import { updateFromStorylines, updateLoading } from "../redux/querySlice";
import {
  decompress,
  isRouter,
  isChatMetaData,
  isVideoClip,
  isAlternateClip,
  isAgentText,
  isRelated,
  isHumanText,
  isStoryMetadata,
  isComplete,
  isOsDebugContext,
  isLlmCallContext,
  isAnswer,
  isStoryline,
  getErrorMessage,
  isVoiceOverVideoClip,
  isHCLiveStreamClip,
} from "./Messages";
import Storylines from "./Storylines";
import VoiceOverCard from "./VoiceOverCard";
import KeySegments from "./KeySegments";

export default function Results(props) {
  let socket = useSocket();
  let wsApiGateway = process.env.REACT_APP_WS_API_GATEWAY_BASE_URL;

  const dispatch = useDispatch();
  const currentThreadID = useSelector((state) => state.activeChatID.value);
  const queryStartDate = useSelector((state) => state.queryText.startDate);
  const queryEndDate = useSelector((state) => state.queryText.endDate);
  const queryType = useSelector((state) => state.queryText.queryType);
  const storylineStartDate = useSelector(
    (state) => state.queryText.storylineStartDate
  );
  const storylineEndDate = useSelector(
    (state) => state.queryText.storylineEndDate
  );
  const fromStorylines = useSelector((state) => state.queryText.fromStorylines);
  const storylineChatId = useSelector(
    (state) => state.queryText.storylineChatId
  );
  const dateRangeStartTime = useSelector((state) => state.dateRange.startDate);
  const dateRangeEndTime = useSelector((state) => state.dateRange.endDate);
  const prompts = useSelector((state) => state.prompts.value);

  const [socketResults, setSocketResults] = useState([]);
  const [agentText, setAgentText] = useState("");
  const [answerText, setAnswerText] = useState("");
  const [chatId, setChatId] = useState("");
  const [startThread, setStartThread] = useState(false);
  const [relatedContent, setRelatedContent] = useState([]);
  const [storyMetadata, setStoryMetadata] = useState([]);
  const [socketComplete, setSocketComplete] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [debugMessages, setDebugMessages] = useState([]);
  const [isQA, setIsQA] = useState(false);
  const [routeType, setRouteType] = useState("");
  const [voiceOver, setVoiceOver] = React.useState(false);
  const [voiceOverResults, setVoiceOverResults] = useState([]);
  const [keySegments, setKeySegments] = useState([]);
  const [allKeySegmentsRecieved, setAllKeySegmentsRecieved] = useState(false);

  const [keyMoments, setKeyMoments] = useState([
    {
      title: "NVIDIA Blackwell Snag",
      url: "https://st-hitchcock-dev-key-moments.s3.us-east-1.amazonaws.com/KM-BlackwellSnag.mov?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEGMaCXVzLWVhc3QtMSJGMEQCIGtOgnjFsLOOHG7Es2AYGH46ggILlp923xAAurnROUuDAiBVg2n2SPE6mXhda3KuOzlJOhvAAEaiF3tnAtCJ8K2FwirTAwiM%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDI0MjIwMTMwMTk3OSIMwKVgfdmSzupoGbv3KqcDoeGo%2FY5d2t4DBAGslh9qbzfNAwbccHjFJqoEOgKicv70VXw%2FJXOYmI4SVD9ZU0L13ME0dawhET%2B96cwAI4%2BsP9RnW%2B9gioOVWoq%2BkB0YnVKysRF9oMmUQmFDthRMfbj%2FRvx5OCGXUkuPx40DKlK8Ax3nXCvsB2o8jnMyN6WN7GgGlx8SjArgPl6xqdO9Zi2uo7amahyNlkYRwhAKpfYoj1RgtPqdZyXbQdKR%2BvUloajVLGzIa8A%2Fo0JvhYr%2BPyTGbztHVjurQUTYBiL8w4TAiOFuE1%2F8m95vFRNySI6Vnk3B4SoY%2BMLfrBhke3qf1oWaJah%2FyiKSIUt4EGOCX7PxIIvrYo7jAK4mO4%2Bbfpu6xbKdBDrv83HhGdX6qL3YBPIvb%2FhRIdf8e4FmlxFeEU7pd3NTgX3%2BM3OmP3xzbWfoRPLchdjXNOeYDZPhURLnQ1KMvFVAj1Ufg%2FQA6HkrWO5ymxyffI5W1K9CSkJO3qs9FKZ3uXIg0iu29ZZVYh9euWnSFZKtQIgiQZ40CF3N4M427rrAZduAD6Kl7zeVJ8PYOVfxlA0h6Oe1MO%2B50b0GOrgCpfokN2JYc0SoIiSoZWaLDAKRuo3uHvrf08lzVTIIcynYuK5rSqNS77SbYmMIc7QZyVcO%2BUE4NIQSYcZ0FkqHEa2HXKMY1t9VBozMMDw9NDniTd9O8ToWlx7BgrEFv8r7dXz8awpRYEbhvQvPHBDBWbO5CIeHKKPuX%2F%2BJmBYqNLUXMQ8uQ9%2BBnvrmp7YJEFOFmXFx%2BMB0aYmLe3Bd5f9BrH1e5AunatIgwt540QMZjgPX6u2OEa6CpdryhmdPLeeg03%2BBHvebCEU7YkZJ0%2FrlWJPjJHEVHuAGCd2vcaC0I3HMPLA%2FhmyXPTTRS9gjKoYIs6RsQsz3UFj5XYmO19YePpdDyrdk93TYBpTTxP0gLHlMY42gAmHXoq%2FQJttKU2H7ZrNH3mzHCb7%2FIVDh8QsYY1Bf9rUWqPo4&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIATQZCSSPN3CAMB4RN%2F20250218%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250218T104157Z&X-Amz-Expires=43200&X-Amz-SignedHeaders=host&X-Amz-Signature=f142e5f5be3b604c0926673be41d961d8cb801bbd8e5ba80f5d6cf7026e42e5b",
    },
    {
      title: "Jensen Huang Exclusive",
      url: "https://st-hitchcock-dev-key-moments.s3.us-east-1.amazonaws.com/KM-JensenHuangExclusive.mov?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEGMaCXVzLWVhc3QtMSJGMEQCIGtOgnjFsLOOHG7Es2AYGH46ggILlp923xAAurnROUuDAiBVg2n2SPE6mXhda3KuOzlJOhvAAEaiF3tnAtCJ8K2FwirTAwiM%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDI0MjIwMTMwMTk3OSIMwKVgfdmSzupoGbv3KqcDoeGo%2FY5d2t4DBAGslh9qbzfNAwbccHjFJqoEOgKicv70VXw%2FJXOYmI4SVD9ZU0L13ME0dawhET%2B96cwAI4%2BsP9RnW%2B9gioOVWoq%2BkB0YnVKysRF9oMmUQmFDthRMfbj%2FRvx5OCGXUkuPx40DKlK8Ax3nXCvsB2o8jnMyN6WN7GgGlx8SjArgPl6xqdO9Zi2uo7amahyNlkYRwhAKpfYoj1RgtPqdZyXbQdKR%2BvUloajVLGzIa8A%2Fo0JvhYr%2BPyTGbztHVjurQUTYBiL8w4TAiOFuE1%2F8m95vFRNySI6Vnk3B4SoY%2BMLfrBhke3qf1oWaJah%2FyiKSIUt4EGOCX7PxIIvrYo7jAK4mO4%2Bbfpu6xbKdBDrv83HhGdX6qL3YBPIvb%2FhRIdf8e4FmlxFeEU7pd3NTgX3%2BM3OmP3xzbWfoRPLchdjXNOeYDZPhURLnQ1KMvFVAj1Ufg%2FQA6HkrWO5ymxyffI5W1K9CSkJO3qs9FKZ3uXIg0iu29ZZVYh9euWnSFZKtQIgiQZ40CF3N4M427rrAZduAD6Kl7zeVJ8PYOVfxlA0h6Oe1MO%2B50b0GOrgCpfokN2JYc0SoIiSoZWaLDAKRuo3uHvrf08lzVTIIcynYuK5rSqNS77SbYmMIc7QZyVcO%2BUE4NIQSYcZ0FkqHEa2HXKMY1t9VBozMMDw9NDniTd9O8ToWlx7BgrEFv8r7dXz8awpRYEbhvQvPHBDBWbO5CIeHKKPuX%2F%2BJmBYqNLUXMQ8uQ9%2BBnvrmp7YJEFOFmXFx%2BMB0aYmLe3Bd5f9BrH1e5AunatIgwt540QMZjgPX6u2OEa6CpdryhmdPLeeg03%2BBHvebCEU7YkZJ0%2FrlWJPjJHEVHuAGCd2vcaC0I3HMPLA%2FhmyXPTTRS9gjKoYIs6RsQsz3UFj5XYmO19YePpdDyrdk93TYBpTTxP0gLHlMY42gAmHXoq%2FQJttKU2H7ZrNH3mzHCb7%2FIVDh8QsYY1Bf9rUWqPo4&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIATQZCSSPN3CAMB4RN%2F20250218%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250218T104232Z&X-Amz-Expires=43200&X-Amz-SignedHeaders=host&X-Amz-Signature=109e3b476585e269f5a5ade14df9662288f9ca701281556c4a43c56ece024148",
    },
    {
      title: "NVIDIA After Hours",
      url: "https://st-hitchcock-dev-key-moments.s3.us-east-1.amazonaws.com/KM-NvidiaAfterHours.mov?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEGMaCXVzLWVhc3QtMSJGMEQCIGtOgnjFsLOOHG7Es2AYGH46ggILlp923xAAurnROUuDAiBVg2n2SPE6mXhda3KuOzlJOhvAAEaiF3tnAtCJ8K2FwirTAwiM%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDI0MjIwMTMwMTk3OSIMwKVgfdmSzupoGbv3KqcDoeGo%2FY5d2t4DBAGslh9qbzfNAwbccHjFJqoEOgKicv70VXw%2FJXOYmI4SVD9ZU0L13ME0dawhET%2B96cwAI4%2BsP9RnW%2B9gioOVWoq%2BkB0YnVKysRF9oMmUQmFDthRMfbj%2FRvx5OCGXUkuPx40DKlK8Ax3nXCvsB2o8jnMyN6WN7GgGlx8SjArgPl6xqdO9Zi2uo7amahyNlkYRwhAKpfYoj1RgtPqdZyXbQdKR%2BvUloajVLGzIa8A%2Fo0JvhYr%2BPyTGbztHVjurQUTYBiL8w4TAiOFuE1%2F8m95vFRNySI6Vnk3B4SoY%2BMLfrBhke3qf1oWaJah%2FyiKSIUt4EGOCX7PxIIvrYo7jAK4mO4%2Bbfpu6xbKdBDrv83HhGdX6qL3YBPIvb%2FhRIdf8e4FmlxFeEU7pd3NTgX3%2BM3OmP3xzbWfoRPLchdjXNOeYDZPhURLnQ1KMvFVAj1Ufg%2FQA6HkrWO5ymxyffI5W1K9CSkJO3qs9FKZ3uXIg0iu29ZZVYh9euWnSFZKtQIgiQZ40CF3N4M427rrAZduAD6Kl7zeVJ8PYOVfxlA0h6Oe1MO%2B50b0GOrgCpfokN2JYc0SoIiSoZWaLDAKRuo3uHvrf08lzVTIIcynYuK5rSqNS77SbYmMIc7QZyVcO%2BUE4NIQSYcZ0FkqHEa2HXKMY1t9VBozMMDw9NDniTd9O8ToWlx7BgrEFv8r7dXz8awpRYEbhvQvPHBDBWbO5CIeHKKPuX%2F%2BJmBYqNLUXMQ8uQ9%2BBnvrmp7YJEFOFmXFx%2BMB0aYmLe3Bd5f9BrH1e5AunatIgwt540QMZjgPX6u2OEa6CpdryhmdPLeeg03%2BBHvebCEU7YkZJ0%2FrlWJPjJHEVHuAGCd2vcaC0I3HMPLA%2FhmyXPTTRS9gjKoYIs6RsQsz3UFj5XYmO19YePpdDyrdk93TYBpTTxP0gLHlMY42gAmHXoq%2FQJttKU2H7ZrNH3mzHCb7%2FIVDh8QsYY1Bf9rUWqPo4&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIATQZCSSPN3CAMB4RN%2F20250218%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250218T104309Z&X-Amz-Expires=43200&X-Amz-SignedHeaders=host&X-Amz-Signature=0156e7a0a423625d7f2c3ff9da8acb44ed4c298ab1ad858e7c7aca3684d98211",
    },
  ]);

  const newChatThread = (id) => {
    setChatId(id);
    setStartThread(true);
    dispatch(updateChatID(id));
    // window.history.pushState("", "", "/q/" + id + "/story");
  };

  const convertToStoryline = (data) => {
    return {
      id: data.id,
      text: data.text,
      start_time: data.start_time,
      end_time: data.end_time,
    };
  };

  const openSocket = () => {
    socket = new WebSocket(wsApiGateway);
  };

  const sendMsg = (e) => {
    if (socket.readyState === 1) {
      console.log("connection is established: ", socket.readyState);
      socket.send(e);
      handleMsg();
    } else {
      console.log("websocket connection state: ", socket.readyState);
      setTimeout(function () {
        sendMsg(e);
      }, 1500);
    }
  };

  const handleMsg = () => {
    dispatch(updateLoading(true));
    socket.onmessage = (data) => {
      let thisMessage = decompress(JSON.parse(data.data));
      let thisMessageSeq;
      let voiceOverMessageSeq;

      if (thisMessage && isChatMetaData(thisMessage) && !startThread) {
        newChatThread(thisMessage["chat_id"]);
      }

      if (isRouter(thisMessage)) {
        setRouteType(thisMessage["route"]);
        if (thisMessage["route"] === "question_answering") {
          setProgressMessage("Curating answer");
        }

        if (thisMessage["route"] === "story_generation") {
          setProgressMessage("Curating story");
        }

        if (thisMessage["route"] === "voiceover_generation") {
          setProgressMessage("Curating voiceover story");
        }

        if (thisMessage["route"] === "holistic_voiceover_generation") {
          setProgressMessage("Curating holistic voiceover story");
        }

        if (thisMessage["route"] === "storyline_generation") {
          setProgressMessage("Curating storylines");
        }

        if (thisMessage["route"] === "analysis_generation") {
          setProgressMessage("Curating analysis");
        }
        if (thisMessage["route"] === "editing_generation") {
          setProgressMessage("Editing story");
        }
        if (thisMessage["route"] === "interview_extraction_capability") {
          setProgressMessage("Finding interview");
        }
      }

      if (isChatMetaData(thisMessage)) {
        setProgressMessage("Curating story");
      }

      if (isVideoClip(thisMessage)) {
        setProgressMessage("Curating videos");
        thisMessageSeq = convertPrimaryClip(thisMessage);
        setSocketResults(socketResults.push(thisMessageSeq));
        dispatch(updateLoading(false));
      } else if (isVoiceOverVideoClip(thisMessage)) {
        setVoiceOver(true);
        setProgressMessage("Curating videos");
        voiceOverMessageSeq = convertVoiceOverClip(thisMessage);
        setVoiceOverResults(voiceOverResults.push(voiceOverMessageSeq));
        dispatch(updateLoading(false));
      } else if (isStoryline(thisMessage)) {
        let storyline = convertToStoryline(thisMessage);
        setSocketResults((socketResults) => [...socketResults, storyline]);
        setVoiceOverResults((voiceOverResults) => [
          ...voiceOverResults,
          storyline,
        ]);
        dispatch(updateLoading(false));
      } else if (isAlternateClip(thisMessage)) {
        setProgressMessage("Curating alternate videos");
        thisMessageSeq = convertAlternateClip(thisMessage);
        voiceOverMessageSeq = convertAlternateClip(thisMessage);
        if (socketResults.length > 0) {
          var found = false;
          for (var i = 0; i < socketResults.length; i++) {
            if (socketResults[i].id === thisMessageSeq.id) {
              socketResults[i].alternate_clips.push(thisMessageSeq);
              break;
            }
          }
          if (found) {
            setSocketResults(socketResults);
          }
        }
        if (voiceOverResults.length > 0) {
          var found = false;
          for (var i = 0; i < voiceOverResults.length; i++) {
            if (voiceOverResults[i].id === voiceOverMessageSeq.id) {
              voiceOverResults[i].alternate_clips.push(voiceOverMessageSeq);
              break;
            }
          }
          if (found) {
            setVoiceOverResults(voiceOverResults);
          }
        }
      } else if (isAgentText(thisMessage)) {
        setAgentText(thisMessage["text"]);
      } else if (isRelated(thisMessage)) {
        setRelatedContent((relatedContent) => [...relatedContent, thisMessage]);
      } else if (isStoryMetadata(thisMessage)) {
        setProgressMessage("Curating story metadata");
        setStoryMetadata(thisMessage);
      } else if (isAnswer(thisMessage)) {
        setAgentText(thisMessage["answer"]);
        setAnswerText(thisMessage["answer"]);
        setIsQA(true);
        dispatch(updateLoading(false));
        setProgressMessage("Reference Videos");
        thisMessage["reference_clips"].forEach((refClip) => {
          setSocketResults(socketResults.push(convertBaseClip(refClip)));
          setVoiceOverResults(voiceOverResults.push(convertBaseClip(refClip)));
        });
      } else if (
        isOsDebugContext(thisMessage) ||
        isLlmCallContext(thisMessage)
      ) {
        setDebugMessages((debugMessages) => [...debugMessages, thisMessage]);
      } else if (isComplete(thisMessage)) {
        setProgressMessage("Curation complete");
        dispatch(updateLoading(false));
        setAllKeySegmentsRecieved(true);
        socket.close();
        setSocketComplete(true);
      } else if (getErrorMessage(thisMessage)) {
        dispatch(updateLoading(false));
        setProgressMessage("Curation complete");
        setAgentText(getErrorMessage(thisMessage));
        setSocketComplete(true);
      } else if (isHCLiveStreamClip(thisMessage)) {
        dispatch(updateLoading(false));
        // let result = {
        //   key_segment_explanation: thisMessage["key_segment_explanation"],
        //   key_segment_score: thisMessage["key_segment_score"],
        //   key_segment_url: thisMessage["video_s3_presigned_url"],
        //   startTime: thisMessage["video_start_time"],
        //   endTime: thisMessage["video_end_time"],
        //   videoDuration: thisMessage["video_duration"],
        // };
        setKeySegments((keySegments) => [...keySegments, thisMessage]);
      } else {
        setSocketResults(socketResults);
        setVoiceOverResults(voiceOverResults);
      }
    };
  };

  const askSmith = () => {
    // console.log("ID in redux store: ", currentThreadID)
    let msg;
    let prompts_str = JSON.stringify(prompts);

    let msg_dict = {
      action: "get-chat-response",
      user_id: sessionStorage.getItem("username"),
      query: props.queryText,
      prompts: prompts_str,
    };

    if (queryType === "topicQuery" || queryType === "feedQuery") {
      msg_dict["capability"] = "key_moment_and_storyline_generation";
    }

    if (!startThread && currentThreadID.length < 8) {
    } else {
      msg_dict["chat_id"] = currentThreadID;
    }

    if (fromStorylines) {
      msg_dict["start_time"] =
        storylineStartDate > 0
          ? storylineStartDate
          : dateRangeStartTime || null;
      msg_dict["end_time"] =
        storylineEndDate > 0 ? storylineEndDate : dateRangeEndTime || null;
    }
    // else {
    //   msg_dict["start_time"] =
    //     queryStartDate > 0 ? queryStartDate : dateRangeStartTime || null;
    //   msg_dict["end_time"] =
    //     queryEndDate > 0 ? queryEndDate : dateRangeEndTime || null;
    // }
    else {
      const currentTime = Math.floor(Date.now());
      const defaultStartTime = Math.floor(currentTime - 72 * 60 * 60 * 1000); // 72 hours ago
      msg_dict["start_time"] = defaultStartTime;
      msg_dict["end_time"] = currentTime;
    }
    // else {
    //   msg_dict["start_time"] = 1740844159220;
    //   msg_dict["end_time"] = 1740844216890;
    // }

    msg = JSON.stringify(msg_dict);

    if (socket.readyState > 1) {
      console.log(
        "WebSocket connection is not OPEN, it is: ",
        socket.readyState
      );
      openSocket();
      setRouteType("");
      setIsQA(false);
      sendMsg(msg);
      dispatch(updateFromStorylines(false));
    } else {
      openSocket();
      setRouteType("");
      setIsQA(false);
      sendMsg(msg);
      handleMsg(msg);
      dispatch(updateFromStorylines(false));
    }

    // setTimeout(socket.send(msg), 1000)
  };

  const formatQueryText = (query) => {
    let storyTitle = query; // query.substring(0, query.length - 30);
    return <div>{storyTitle}</div>;
    // return query.replace(/from dates .*$/g, " ").trim();
  };

  const convertBaseClip = (clip) => {
    var new_clip = {
      first_pub_date: moment(clip["video_timestamp"]?.["epoch_millis"]).format(
        "MMMM DD, YYYY"
      ),
      clip_id: clip["clip_id"],
      media_start_time: parseFloat(clip["video_start_time"]) / 1000,
      media_end_time: parseFloat(clip["video_end_time"]) / 1000,
      duration: parseFloat(clip["video_duration"]) / 1000,
      media_url: clip["video_s3_presigned_url"],
      media_thumbnail: clip["thumbnail_s3_presigned_url"],

      video_start_time: clip["video_start_time"],
      video_end_time: clip["video_end_time"],
      video_duration: clip["video_duration"],
      clip_duration:
        parseFloat(clip["video_end_time"] - clip["video_start_time"]) / 1000,
      video_s3_presigned_url: clip["video_s3_presigned_url"],
      thumbnail_s3_presigned_url: clip["thumbnail_s3_presigned_url"],
      caption: clip["video_caption"],

      location: clip["location"],
      timed_captions: clip["timed_captions"],
      guest_speakers: clip["guest_speakers"],
      summary: clip["summary"],
      moment_summary: clip["moment_summary"],
      program_name: clip["program_name"],
    };
    return new_clip;
  };

  const convertVoiceOverAudioClip = (clip) => {
    var new_clip = {
      clip_id: clip["clip_id"],
      duration: parseFloat(clip["audio_duration"]) / 1000,
      media_url: clip["audio_s3_presigned_url"],
      audio_duration: clip["audio_duration"],
      audio_s3_presigned_url: clip["audio_s3_presigned_url"],
      caption: clip["audio_caption"],
    };
    return new_clip;
  };

  const convertVoiceOverOverlayClip = (clip) => {
    var new_clip = {
      first_pub_date: moment(clip["video_timestamp"]?.["epoch_millis"]).format(
        "MMMM DD, YYYY"
      ),
      clip_id: clip["clip_id"],
      media_start_time: parseFloat(clip["video_start_time"]) / 1000,
      media_end_time: parseFloat(clip["video_end_time"]) / 1000,
      duration: parseFloat(clip["video_duration"]) / 1000,
      media_url: clip["video_s3_presigned_url"],
      media_thumbnail: clip["thumbnail_s3_presigned_url"],

      video_start_time: clip["video_start_time"],
      video_end_time: clip["video_end_time"],
      video_duration: clip["video_duration"],
      clip_duration:
        parseFloat(clip["video_end_time"] - clip["video_start_time"]) / 1000,
      video_s3_presigned_url: clip["video_s3_presigned_url"],
      thumbnail_s3_presigned_url: clip["thumbnail_s3_presigned_url"],
      caption: clip["video_caption"],

      location: clip["location"],
      timed_captions: clip["timed_captions"],
      guest_speakers: clip["guest_speakers"],
      summary: clip["summary"],
      moment_summary: clip["moment_summary"],
      program_name: clip["program_name"],
      overlay_start_time: clip["overlay_start_time"],
      overlay_end_time: clip["overlay_end_time"],
    };
    return new_clip;
  };

  const convertVoiceOverClip = (clip) => {
    let new_clip;
    new_clip = convertVoiceOverAudioClip(clip);
    let overlay_clips = clip.overlay_clips.map((item) =>
      convertVoiceOverOverlayClip(item)
    );
    new_clip.overlay_clips = overlay_clips;
    new_clip.id = clip["video_story_clip_id"];
    new_clip.alternate_clips = clip["alternate_clips"]
      ? clip["alternate_clips"]
      : [];
    return new_clip;
  };

  const convertPrimaryClip = (clip) => {
    var new_clip = convertBaseClip(clip);
    new_clip.id = clip["video_story_clip_id"];
    new_clip.caption = clip["narrative_text"];
    new_clip.alternate_clips = clip["alternate_clips"];
    return new_clip;
  };

  const convertAlternateClip = (clip) => {
    var new_clip = convertBaseClip(clip);
    new_clip.id = clip["video_story_clip_id"];
    return new_clip;
  };

  const convert_history_clips = (clips) => {
    // need to convert the clips from the format from the history call to the format the UI expects
    var newclips = [];
    clips.forEach((clip) => {
      var newclip = convertPrimaryClip(clip);
      clip["alternate_clips"].forEach((alt_clip) => {
        var new_alt_clip = convertAlternateClip(alt_clip);
        newclip["alternate_clips"].push(new_alt_clip);
      });
      newclips.push(newclip);
    });
    return newclips;
  };

  useEffect(() => {
    if (
      !props.isHistory ||
      (props.isHistory &&
        props.addToHistory &&
        Object.keys(props.activityLog).length > 0 &&
        props.queryText.length > 0)
    ) {
      askSmith();
    }
  }, [props.queryText]);

  useEffect(() => {
    console.log("connection status: ", socket.readyState);
  }, []);

  return (
    <Box
      style={{
        marginBottom: 80,
        // padding: "1rem",
      }}
    >
      {props.isHistory === true ? (
        <div>
          <Chip
            label="From your recent activity"
            sx={{ mb: 2 }}
            icon={<HistoryIcon />}
          />
          {props.activityLog &&
            props.activityLog.map((item) => {
              // map through whole activity log and group by message_id
              let collection = [];
              let altCollection = [];
              let routeType = "";
              let agentText = "";
              let historyQueryText = "";
              let storyMetadata = [];
              let qaCollection = [];
              {
                /* console.log("key: ", key);
            console.log("key group object: ", props.activityLog[key]); */
              }

              item.map((message) => {
                // check message type
                if (isHumanText(message)) {
                  historyQueryText = message["text"];
                }
                if (isRouter(message)) {
                  routeType = message.route;
                }
                if (isStoryline(message)) {
                  collection.push(message);
                }
                if (isAlternateClip(message)) {
                  altCollection.push(message);
                }
                if (isVideoClip(message)) {
                  collection.push(message);
                }
                if (isAgentText(message)) {
                  agentText = message.agentText;
                }
                if (isAnswer(message)) {
                  qaCollection.push(message["reference_clips"]);
                }
                if (isStoryMetadata(message)) {
                  storyMetadata = message;
                }
              });
              if (routeType === "storyline_generation") {
                // render storyline
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        color: "#666666",
                      }}
                    >
                      <AccountCircle
                        sx={{
                          color: "#666666",
                          fontSize: "28px",
                          marginRight: "4px",
                        }}
                      />
                      {historyQueryText}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: 12,
                        marginBottom: 48,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "top",
                          marginTop: 4,
                          marginBottom: 12,
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#AC1FFF",
                        }}
                      >
                        <img
                          src={logo}
                          width={24}
                          alt="logo"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <Storylines
                        // query={historyQueryText}
                        stories={collection}
                        agentText={agentText}
                        debug_messages={debugMessages}
                      />
                    </div>
                  </>
                );
              } else if (routeType === "question_answering") {
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        color: "#666666",
                      }}
                    >
                      <AccountCircle
                        sx={{
                          color: "#666666",
                          fontSize: "28px",
                          marginRight: "4px",
                        }}
                      />
                      {historyQueryText}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: 12,
                        marginBottom: 48,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "top",
                          marginTop: 4,
                          marginBottom: 12,
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#AC1FFF",
                        }}
                      >
                        <img
                          src={logo}
                          width={24}
                          alt="logo"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <VideoCard
                        compilation={qaCollection}
                        isQA={true}
                        storyMetadata={storyMetadata}
                      />
                    </div>
                  </>
                );
              } else {
                // render other videocard options (q&a, editing, analysis, story)
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 600,
                        color: "#666666",
                      }}
                    >
                      <AccountCircle
                        sx={{
                          color: "#666666",
                          fontSize: "28px",
                          marginRight: "4px",
                        }}
                      />
                      {historyQueryText}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: 12,
                        marginBottom: 48,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "top",
                          marginTop: 4,
                          marginBottom: 12,
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#AC1FFF",
                        }}
                      >
                        <img
                          src={logo}
                          width={24}
                          alt="logo"
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                      <VideoCard
                        compilation={collection}
                        socketComplete={true}
                        message="Curation complete"
                        storyMetadata={storyMetadata}
                      />
                    </div>
                  </>
                );
              }
            })}

          {props.addToHistory === true && props.queryText.length > 1 && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "#666666",
                }}
              >
                <AccountCircle
                  sx={{
                    color: "#666666",
                    fontSize: "28px",
                    marginRight: "4px",
                  }}
                />
                {formatQueryText(props.queryText)}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "top",
                    marginTop: 4,
                    marginBottom: 12,
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#AC1FFF",
                  }}
                >
                  <img src={logo} width={24} style={{ marginRight: "10px" }} />
                </div>
                <div style={{ width: "100%" }}>
                  <VideoCard
                    compilation={socketResults}
                    theme={props.theme}
                    agentText={agentText}
                    answerText={answerText}
                    isQA={isQA}
                    storyMetadata={storyMetadata}
                    socketComplete={socketComplete}
                    open_alt_clips_panel={props.open_alt_clips_panel}
                    alt_clips_drawer={props.alt_clips_drawer}
                    open_debug_panel={props.open_debug_panel}
                    debug_drawer={props.debug_drawer}
                    debug_messages={debugMessages}
                    message={progressMessage}
                  />
                  <Carousel
                    items={relatedContent}
                    socketComplete={socketComplete}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : props.queryText !== "" ? (
        <>
          <Grid container paddingInline={8}>
            <Grid item width={"100%"} mb={2}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  fontSize: "1.3rem",
                  color: "#666666",
                }}
              >
                <AccountCircle
                  sx={{
                    color: "#666666",
                    fontSize: "28px",
                    marginRight: "4px",
                  }}
                />
                {formatQueryText(props.queryText)}
              </div>
            </Grid>
            {(queryType === "topicQuery" || queryType === "feedQuery") && (
              <KeySegments
                queryText={props.queryText}
                keySegments={keySegments}
                socketComplete={socketComplete}
              />
            )}
            <Grid item sm={12} md={8}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // marginTop: 4,
                    marginBottom: 12,
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#AC1FFF",
                  }}
                >
                  <img
                    src={logo}
                    width={24}
                    alt="logo"
                    style={{ marginRight: "10px" }}
                  />
                  {!routeType && (
                    <code className="progress">
                      <span>Fetching route</span>
                      <CircularProgress
                        size={18}
                        thickness={8}
                        sx={{
                          marginLeft: "12px",
                          verticalAlign: "middle",
                          color: "#AC1FFF",
                        }}
                      />
                    </code>
                  )}
                </div>
                <div style={{ width: "100%" }}>
                  {(routeType === "question_answering" ||
                    routeType === "story_generation" ||
                    routeType === "editing_generation" ||
                    routeType === "analysis_generation" ||
                    routeType === "voiceover_generation" ||
                    routeType === "holistic_voiceover_generation" ||
                    routeType === "interview_extraction_capability") && (
                    <>
                      {/* {process.env.REACT_APP_ENVIRONMENT !== "production" && (
                        <p
                          style={{
                            fontSize: 10,
                            marginBottom: 0,
                            fontFamily: "monospace",
                          }}
                        >
                          Route: {routeType}
                        </p>
                      )} */}
                      {voiceOver === true ||
                      routeType === "voiceover_generation" ||
                      routeType === "holistic_voiceover_generation" ? (
                        <VoiceOverCard
                          compilation={voiceOverResults}
                          theme={props.theme}
                          answerText={answerText}
                          agentText={agentText}
                          isQA={isQA}
                          storyMetadata={storyMetadata}
                          socketComplete={socketComplete}
                          open_alt_clips_panel={props.open_alt_clips_panel}
                          alt_clips_drawer={props.alt_clips_drawer}
                          open_debug_panel={props.open_debug_panel}
                          debug_drawer={props.debug_drawer}
                          debug_messages={debugMessages}
                          message={progressMessage}
                        />
                      ) : (
                        <VideoCard
                          compilation={socketResults}
                          theme={props.theme}
                          answerText={answerText}
                          agentText={agentText}
                          isQA={isQA}
                          storyMetadata={storyMetadata}
                          socketComplete={socketComplete}
                          open_alt_clips_panel={props.open_alt_clips_panel}
                          alt_clips_drawer={props.alt_clips_drawer}
                          open_debug_panel={props.open_debug_panel}
                          debug_drawer={props.debug_drawer}
                          debug_messages={debugMessages}
                          message={progressMessage}
                        />
                      )}
                      <Carousel
                        items={relatedContent}
                        socketComplete={socketComplete}
                      />
                    </>
                  )}
                  {routeType === "storyline_generation" ||
                    (routeType === "key_moment_and_storyline_generation" && (
                      <>
                        {/* {process.env.REACT_APP_ENVIRONMENT !== "production" && (
                          <p
                            style={{
                              fontSize: 10,
                              marginBottom: 0,
                              fontFamily: "monospace",
                            }}
                          >
                            Route: {routeType}
                          </p>
                        )} */}
                        <Storylines
                          query={props.queryText}
                          stories={socketResults}
                          message={progressMessage}
                          agentText={agentText}
                          debug_messages={debugMessages}
                        />
                      </>
                    ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </>
      ) : null}
    </Box>
  );
}
